import React from 'react';
import Icon from '../../components/Icon';
import './DropZone.css';

/**
 * F11.3 — Drop zone overlay.
 *
 * Renders the dashed overlay that appears when the user drags files over the
 * Beam workspace AND a peer is selected. Mirrors `design/sharing-screens.jsx`
 * artboard 19 (`.dropzone` + `.dz-ico`).
 *
 * Pure view: the parent (DesktopBeam) owns the drag state via `useFileDrop`
 * and the `selectedPeerId` ref, and feeds the result here.
 *
 * Props:
 *  - `visible`  — when false, the overlay sits in the DOM with
 *                 `pointer-events: none` and `opacity: 0` so it doesn't
 *                 swallow clicks on the underlying device list. When true,
 *                 the dashed-border treatment fades in.
 *  - `peerName` — display name of the selected peer (shown in the headline).
 */
const DropZone = ({ visible, peerName }) => {
  // Keep the markup mounted so React doesn't churn on transitions — the
  // `.hidden` class drives visibility entirely via CSS.
  const cls = 'dropzone' + (visible ? '' : ' hidden');
  return (
    <div
      className={cls}
      data-testid="beam-dropzone"
      aria-hidden={visible ? undefined : 'true'}
      role={visible ? 'presentation' : undefined}
    >
      <div className="dz-ico" aria-hidden="true">
        <Icon name="upload" size={32} stroke="var(--lan)" />
      </div>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 18, fontWeight: 600 }}>
          Drop to beam to{' '}
          <span style={{ color: 'var(--lan)' }}>{peerName || 'this peer'}</span>
        </div>
        <div
          style={{
            fontSize: 12,
            color: 'rgba(255,255,255,.65)',
            marginTop: 4,
          }}
        >
          Direct over LAN · files never touch a server
        </div>
      </div>
    </div>
  );
};

export default DropZone;
